import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AimOutlinedSvg from "@ant-design/icons-svg/es/asn/AimOutlined";
import AntdIcon from "../components/AntdIcon";
var AimOutlined = function AimOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AimOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AimOutlined.displayName = 'AimOutlined';
}
export default /*#__PURE__*/React.forwardRef(AimOutlined);